import type { FaireProductEntity } from "../../entity_types/product";

export const p_2se20fsl6y: FaireProductEntity = {
  token: "p_2se20fsl6y",
  type: "product",
  name: "Golden Coast - 7.75 fl oz Room & Linen Spray",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7a2eb0f17c1031ecd7fe4aa2d23c23ef74b8781e649356765dba7060ed4b9891.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/806c2292c9e764b1c819aa2c931adcd103549e241f8da09a1df5734bc44f03b9.webp",
    "https://cdn.faire.com/fastly/f0b03df716ad6a212699b3f84633f58d9c833cb4e45de368ea7ed4c4279679ff.jpeg",
    "https://cdn.faire.com/fastly/e65c4504ef23967860fe77e028fd59d0b80bc68eb59147c696dd4a12ccc768fa.jpeg",
    "https://cdn.faire.com/fastly/33dc47d37698aed017cd2303808ec585cdfd016104910b6f319d1209f8fb2e0e.jpeg",
    "https://cdn.faire.com/fastly/c8204198990372227fbca763174af767f6553facc4394d12aa05d2aec7aa9d35.jpeg",
    "https://cdn.faire.com/fastly/bc5a0c814899f777c13d6bdd067084d1a868270b280ceb550a2f0c344844dee1.jpeg",
    "https://cdn.faire.com/fastly/92c380a966cb4b7aa888644ea633272196abffc9515d6589e28c4e7bc1f82fdd.jpeg",
  ],
  priceDollars: 10,
  description:
    "Big Sur magic, wild sage baking in the sun, the rumble of waves and rocks. Eucalyptus, sea salt, redwood, and palo santo.\n\nOur Room & Linen Sprays offer an effortless, fine mist with a light fragrance! Meant for daily use on bedsheets, pillows, couches - anywhere that needs a bit of a boost. \n\nFragrance lasts longest when applied directly onto fabrics, especially any with a thicker weave.\n\nEach 7.75 oz amber bottle contains water, phthalate-free premium fragrance oil (body safe), and two cosmetic-grade preservatives meant to maintain quality and prolong shelf-life: phenoxyethanol and caprylyl glycol.\n\nYour customers might also like fresh Amber & Moss.\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:51.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
